import Swal from "sweetalert2";

export function handleApiError(error) {
  console.error("API Error:", error);

  if (error.response) {
    const { status, data } = error.response;

    if ([422, 404].includes(status)) {
      if (data.errors && typeof data.errors === "object") {
        const allMessages = Object.values(data.errors).flat().join("<br>");

        Swal.fire({
          icon: "error",
          title: "Validation Error",
          html: allMessages,
        });
      } else if (data.message) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.message,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Validation error occurred.",
        });
      }
    } else if (status === 401) {
      Swal.fire({
        icon: "error",
        title: "Unauthorized",
        text: "Unauthorized access. Please log in again.",
      });
    } else if (status === 400) {
      Swal.fire({
        icon: "error",
        title: "Unauthorized",
        text: error.response.data.message || "An error occurred.",
      });
    } else if (status === 403) {
      Swal.fire({
        icon: "error",
        title: "Forbidden",
        text: "Access denied. You do not have permission.",
      });
    } else if (status === 500) {
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Internal server error. Please try again later.",
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: data.message || "An unexpected error occurred.",
      });
    }
  } else if (error.request) {
    Swal.fire({
      icon: "error",
      title: "Network Error",
      text: "Check your internet connection.",
    });
  } else {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "An unexpected error occurred.",
    });
  }
}